import type { TFunction } from 'i18next';
import { string } from 'yup';

const make = (t: TFunction) =>
  string().required(t('emailIsRequired')).email(t('pleaseEnterAValidEmail'));

export { make };
